import { firestoreAction } from 'vuexfire'
import * as firebase from 'firebase'
import db from '@/db'

const teamRef = db.collection('team')
const orgRef = db.collection('organization')
const tasksRef = db.collection('tasks')
const updated = firebase.default.firestore.FieldValue.serverTimestamp()

const initialState = {
  team: [],
  teamLoading: true
}

const state = Object.assign({}, initialState)

const mutations = {
  'SET_TEAM_LOADING' (state, loading) {
    state.teamLoading = loading
  },
  'RESET_STATE' (state) {
    for (let prop in state) {
      state[prop] = initialState[prop]
    }
  }
}

const actions = {
  resetTeamState: firestoreAction(({ commit, unbindFirestoreRef }) => {
    unbindFirestoreRef('team')
    commit('RESET_STATE')
  }),
  setTeamRef: firestoreAction(({ bindFirestoreRef, commit, dispatch }, ref) => {
    bindFirestoreRef('team', ref).then(response => {
      commit('SET_TEAM_LOADING', false)
      dispatch('toggleLoading', false)
    }).catch(error => {
      console.log(error)
    })
  }),
  addPerson: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      let person = { ...payload }
      teamRef.add(person).then(entry => {
        let teamInfo = {
          updated: updated
        }
        const teamKey = 'team.' + entry.id
        teamInfo[teamKey] = true
        orgRef.doc(payload.organization).update(teamInfo).then(response => {
          dispatch('saveState', true)
        }).catch(error => {
          console.log(error)
        })
        resolve(entry.id)
      }).catch(error => {
        console.log(error)
      })
    })
  },
  editPerson: ({ dispatch }, payload) => {
    let teamInfo = { ...payload }
    teamInfo.updated = updated
    teamRef.doc(teamInfo.id).update(teamInfo).then(person => {
      dispatch('saveState', true)
    }).catch(error => {
      console.log(error)
    })
  },
  removePerson: ({ commit, dispatch, rootGetters }, payload) => {
    const tasks = rootGetters.teamTasks(payload.id)
    const batch = db.batch()
    const person = teamRef.doc(payload.id)
    batch.delete(person)

    // Remove person from all tasks
    tasks.forEach(task => {
      const taskDoc = tasksRef.doc(task.id)
      const taskInfo = {
        updated: updated,
        person: false
      }
      batch.update(taskDoc, taskInfo)
    })

    // Rmove from org
    const org = orgRef.doc(payload.organization)
    const orgField = 'team.' + payload.id
    const orgInfo = {}
    orgInfo.updated = updated
    orgInfo[orgField] = firebase.default.firestore.FieldValue.delete()
    batch.update(org, orgInfo)
    batch.commit().then(response => {
      dispatch('saveState', true)
    })
  },
  duplicateTeam: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      const oldTeam = { ...state.team }
      const teamMatrix = {}
      const batch = db.batch()
      let teamCount = 0
      Object.keys(oldTeam).forEach(person => {
        const newMember = { ...oldTeam[person] }
        const oldMember = oldTeam[person].id
        delete newMember.id
        newMember.owner = payload.user
        newMember.created = updated
        newMember.updated = updated
        newMember.organization = payload.org
        teamRef.add(newMember).then(reference => {
          teamMatrix[oldMember] = reference.id
          const org = orgRef.doc(payload.org)
          const orgKey = 'team.' + reference.id
          const orgInfo = {}
          orgInfo[orgKey] = true
          batch.update(org, orgInfo)
          teamCount++
          if (teamCount === state.team.length) {
            commitBatch()
          }
        })
        function commitBatch () {
          batch.commit().then(response => {
            resolve(teamMatrix)
          }, error => {
            reject(error)
          })
        }
      })
    })
  }
}

const getters = {
  teamLoading: state => {
    return state.teamLoading
  },
  team: (state, rootGetters) => {
    const org = rootGetters.organization.id
    return state.team.filter(team => team.archived === false).filter(team => team.organization === org)
  },
  person: state => (key) => {
    return state.team.find(team => team.id === key)
  },
  teamList: state => {
    return state.team.map(team => {
      return {
        label: team.firstName + ' ' + team.lastName + ' · ' + team.title,
        value: team.id
      }
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
